import '../../../common/dashboard/filters/composite_filter.js.coffee';# Added by Script 
Namespace 'CustomerVisualMode.Filters'

class CustomerVisualMode.Filters.CompositeFilter extends Common.Dashboard.Filters.CompositeFilter

  FILTERS = CustomerVisualMode.Filters

  _parse: (json) ->
    @_mergeTicketAttributesFilters(super(json))

  _mergeTicketAttributesFilters: (filters) ->
    ticketAttributeFilterType = FILTERS.TicketAttributesFilter.FILTER_TYPE
    ticketAttributesFiltersValues = filters.filter(
      (filter) -> filter.getFilterType() == ticketAttributeFilterType
    ).map((filter) -> filter.values)
    return filters unless ticketAttributesFiltersValues.length > 1
    ticketAttributeFilterIndex = filters.findIndex((filter) -> filter.getFilterType() == ticketAttributeFilterType)
    ticketAttributeFilterToBeMerged = filters[ticketAttributeFilterIndex]
    ticketAttributeFilterToBeMerged.values = _.assign({}, ticketAttributesFiltersValues...)
    filtersWithoutTicketAttributesFilter = filters.filter(
      (filter) -> filter.getFilterType() != ticketAttributeFilterType
    )
    filtersWithoutTicketAttributesFilter.splice(ticketAttributeFilterIndex, 0, ticketAttributeFilterToBeMerged)
    filtersWithoutTicketAttributesFilter

  filterWithType: (type) ->
    filtersTypes = [FILTERS.FixedStringAttributeFilter.FILTER_TYPE, FILTERS.HierarchicalTagsAttributeFilter.FILTER_TYPE]
    type = FILTERS.TicketAttributesFilter.FILTER_TYPE if filtersTypes.includes(type)
    super(type)
